import axios from 'axios'
import { authenticatedAxios, reportingAxios, coreCompanyAxios } from './axiosConfig.js'

/**
 * Instancia de Axios SIN autenticación para rutas públicas.
 * No incluye tokens en las peticiones.
 */
export const unAuthenticatedAxios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 30000,
})

/**
 * Instancia de Axios CON autenticación para el servicio de informes.
 * Los interceptores agregan automáticamente el Bearer token.
 * Configurada mediante VITE_INFORMES_SERVICE_URL.
 *
 * @see axiosConfig.js para la configuración de interceptores
 */
export const informesAxios = authenticatedAxios

/**
 * Instancia de Axios CON autenticación para el gateway de reporting.
 * Los interceptores agregan automáticamente el Bearer token.
 * Configurada mediante VITE_API_GATEWAY_REPORTING.
 *
 * @see axiosConfig.js para la configuración de interceptores
 */
export const reportingService = reportingAxios

/**
 * Instancia de Axios CON autenticación para el gateway de company (core).
 * Los interceptores agregan automáticamente el Bearer token.
 * Configurada mediante VITE_API_GATEWAY_CORE_COMPANY.
 *
 * @see axiosConfig.js para la configuración de interceptores
 */
export const companyService = coreCompanyAxios
